import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";

import AddInventory from '../../inventory/add/add-inventory.component';
import Button from '../../reusable/button/button.component';
import ComponentModal from '../../reusable/component-modal/component-modal.component';
import InventoriesWrapper from '../../inventory/inventories-wrapper/inventories-wrapper.component';
import UpdateProduct from './update-product/update-product.component';

import {
  RowContainer
} from '../../../styles/component.styles';

import {
  MainContainer,
  ProductContainerRow,
  ProductDataContainer,
  ProductDataText,
  ProductDataTitle,
  ProductOptionsContainer
} from './product-display.styles';

const ProductDisplay = ({ product, getProduct = async () => {} }) => {
  const navigate = useNavigate();
  const [showUpdate, setShowUpdate] = useState(false);
  const [showAddInventory, setShowAddInventory] = useState(false);

  const updateInventorySuccess = async () => {
    await getProduct();
    setShowAddInventory(false);
  };

  const renderDynamicDetails = () => {
    const fields = product.ProductType?.ProductTypeFields || [];
    return fields
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map(field => {
        const value = product.details?.[field.key];
        if (value === undefined || value === null || value === '') return null;

        let displayValue = value;

        if (field.type === 'select' && Array.isArray(field.options)) {
          const matched = field.options.find(opt => opt.value === value);
          displayValue = matched ? matched.label || matched.value : value;
        }

        if (field.type === 'boolean') {
          displayValue = value ? 'Yes' : 'No';
        }

        if (field.type === 'date') {
          const date = new Date(value);
          displayValue = isNaN(date) ? value : date.toLocaleDateString();
        }

        return (
          <ProductContainerRow key={field.key}>
            <ProductDataTitle>{field.label}:</ProductDataTitle>
            <ProductDataText>{displayValue}</ProductDataText>
          </ProductContainerRow>
        );
      });
  };

  return (
    <MainContainer>
      <ComponentModal isOpen={showUpdate} onClose={() => setShowUpdate(false)} title="Update Product">
        <UpdateProduct
          product={product}
          getProduct={getProduct}
          setShowUpdate={setShowUpdate}
        />
      </ComponentModal>
      <ComponentModal isOpen={showAddInventory} onClose={() => setShowAddInventory(false)} title="Add Inventory">
        <AddInventory
          product={product}
          onComplete={getProduct}
          onClose={() => setShowAddInventory(false)}
          onSuccess={() => updateInventorySuccess()}
        />
      </ComponentModal>
      <ProductOptionsContainer>
        <FaEdit onClick={() => setShowUpdate(true)} />
      </ProductOptionsContainer>
      <ProductDataContainer>
        <ProductContainerRow onClick={() => navigate(`/categories/${product.Category.id}`)} cursor={'pointer'}>
          <ProductDataTitle>Category: </ProductDataTitle>
          <ProductDataText>{product.Category.name}</ProductDataText>
        </ProductContainerRow>
        <ProductContainerRow>
          <ProductDataTitle>Type: </ProductDataTitle>
          <ProductDataText>{product?.ProductType?.name}</ProductDataText>
        </ProductContainerRow>
        <ProductContainerRow>
          <ProductDataTitle>Name: </ProductDataTitle>
          <ProductDataText>{product.name}</ProductDataText>
        </ProductContainerRow>
        <ProductContainerRow>
          <ProductDataTitle>Slug: </ProductDataTitle>
          <ProductDataText>{product.slug}</ProductDataText>
        </ProductContainerRow>
        <ProductContainerRow>
          <ProductDataTitle>Description: </ProductDataTitle>
          <ProductDataText>{product.description}</ProductDataText>
        </ProductContainerRow>
        {renderDynamicDetails()}
      </ProductDataContainer>
      <RowContainer margin={'10px 0'}>
        <Button onClick={() => setShowAddInventory(true)}>New Inventory</Button>
      </RowContainer>
      <InventoriesWrapper productId={product.id} />
    </MainContainer>
  );
};

export default ProductDisplay;